import { useState } from 'react';
import { FormControl, FormLabel, VStack, Stack, Box } from '@chakra-ui/react';
import { Select } from 'chakra-react-select';

import FieldToolTip from 'components/forms/new/FieldToolTip';
import FieldError from 'components/forms/new/FieldError';

import {
    stackStyling,
    formLabelStyling,
} from 'components/forms/new/formStyles';
import {
    chakraSelectDarkMode,
    defaultChakraSelectStyle,
} from 'pages/telephony/numbers/requestBlock/constants';

const SelectField = ({
    colorScheme,
    darkMode,
    state,
    stateError,
    field,
    options,
    onChange,
    children,
    walkthroughId,
    tooltipLabel,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const chakraSelectDark = chakraSelectDarkMode(darkMode);
    const chakraStyles = {
        ...defaultChakraSelectStyle,
        ...chakraSelectDark,
    };
    return (
        <FormControl
            isRequired
            isInvalid={!state?.[field]}
            dataWalkthroughid={walkthroughId}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            data-cy={`input-${field}`}>
            <Stack direction="row" sx={stackStyling()}>
                <Box width={190}>
                    <FormLabel
                        sx={{
                            ...formLabelStyling(darkMode),
                        }}>
                        {children}
                    </FormLabel>
                </Box>
                <Box
                    flex="1"
                    sx={{
                        paddingTop: '15px',
                    }}>
                    <VStack
                        alignItems="normal"
                        width="90%"
                        sx={{
                            '& .chakra-react-select__control, & .chakra-react-select__input-container':
                                {
                                    height: '30px',
                                    minH: '30px',
                                    '& .chakra-react-select__single-value': {
                                        height: '20px',
                                        ml: 0,
                                    },
                                },
                        }}>
                        <Select
                            tabSelectsValue
                            openMenuOnFocus
                            placeholder=" "
                            value={options.find(
                                (i) => i.value === state?.[field],
                            )}
                            options={options}
                            onChange={onChange}
                            chakraStyles={chakraStyles}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                }),
                                container: (base) => ({
                                    ...base,
                                    backgroundColor: 'transparent',
                                }),
                            }}
                            classNamePrefix="chakra-react-select"
                            colorScheme={colorScheme}
                            selectedOptionColor={colorScheme}
                        />
                    </VStack>
                </Box>

                {isHovered && (
                    <FieldToolTip
                        label={tooltipLabel}
                        ariaLabel={`${tooltipLabel}-tip`}
                        right="25px"
                        top="23px"
                    />
                )}
            </Stack>
            <FieldError>
                {stateError?.[field] || 'Field is required.'}
            </FieldError>
        </FormControl>
    );
};

export default SelectField;
